import {Component, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import moment from 'moment';
import {DataService} from '../services/data.service';
import {MatCalendarCellCssClasses} from '@angular/material/datepicker';
import {faAngleLeft, faAngleRight, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';
import {EmpWeekPlan} from '../models/employees-model';
import {SharedDataService} from '../services/shared-data.service';
import {DialogService} from '../services/dialog.service';
import {MessageBoxService} from '../../services/message-box.service';

@Component({
    selector: 'app-share-emp-order',
    templateUrl: './share-emp-order.component.html',
    styleUrls: ['./share-emp-order.component.scss']
})
export class ShareEmpOrderComponent implements OnInit {
    faAngleLeft = faAngleLeft;
    faAngleRight = faAngleRight;
    faExclamationCircle = faExclamationCircle;
    formValue = new UntypedFormControl('');

    public filteredEmpWorkPlan: EmpWeekPlan[] = [];

    constructor(
        private router: Router,
        private _datumFormatPipe: DatumFormatPipe,
        private dialogService: DialogService,
        private shareDataService: SharedDataService,
        private dataService: DataService,
        private messageBoxService: MessageBoxService
    ) {
    }

    ngOnInit(): void {
        this.dataService.getChosenDateAsPromise().then((res) => {
            this.formValue.setValue(res);
        });
    }

    ngAfterViewInit() {
        this.formValue.valueChanges.subscribe({
            next: (res) => {
                this.loadOrdersFromDay(res);
            },
        });
    }

    getIconStyle(value: number): Object {
        if (value === 1) {
            return {color: 'red', 'margin-top': '-8px'};
        } else if (value === 2) {
            return {color: 'red', 'margin-top': '-4px'};
        }
        return {};
    }

    previous() {
        const previousDay = moment(this.formValue.value)
            .subtract(1, 'days')
            .format();
        this.formValue.setValue(new Date(previousDay));
    }

    next() {
        const nextDay = moment(this.formValue.value).add(1, 'days').format();
        this.formValue.setValue(new Date(nextDay));
    }

    loadOrdersFromDay(datum: any) {
        if (!(datum instanceof Date)) {
            datum = datum.toDate();
        }

        const strDatumOhneZeit = this._datumFormatPipe.transformEN(this._datumFormatPipe.removeTimeFromDate(datum)).substring(0, 10);
        this.dataService.getPlannedEmployeeWeeks().then(x => {
            this.filteredEmpWorkPlan = x.filter(wp => wp.planDay!.substring(0, 10) == strDatumOhneZeit);
            this.filteredEmpWorkPlan = this.filteredEmpWorkPlan.sort((a: EmpWeekPlan, b: EmpWeekPlan) => {
                if (a.sort > b.sort) {
                    return 1;
                }
                if (a.sort < b.sort) {
                    return -1;
                }
                return 0;
            });
        });
    }

    dateClass() {
        return async (date: Date): Promise<MatCalendarCellCssClasses> => {
            date = new Date(date);
            const highlightDate = (await this.dataService.getTimeEntriesFromIndexedDB()).some((d) => {
                return (
                    new Date(d.entryDate).getDate() === new Date(date).getDate() &&
                    new Date(d.entryDate).getMonth() === new Date(date).getMonth() &&
                    new Date(d.entryDate).getFullYear() === new Date(date).getFullYear()
                );
            });
            return highlightDate ? 'swiss-date-class' : '';
        };
    }

    getClientName(item: EmpWeekPlan): string {
        const foundOrder = this.dataService.getIndexedDBData().orders.find(
            (el) => el.objectID === item.objectID
        );

        let loc = '';
        if (foundOrder?.lastname) {
            loc = foundOrder?.lastname!;
        }

        if (item.note4) {
            loc += ' ' + item.note4;
        }

        return loc;
    }

    choosedOrder(item: EmpWeekPlan) {
        this.shareDataService.changeMessage(item, 'shareEmpOrder');
        this.router.navigateByUrl('/timeapp');
    }

    showNotes(ev: MouseEvent, item: EmpWeekPlan) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        this.messageBoxService.askYesNoQuestion('MAIN_APP_DIALOG.SHARE_EMP_NOTE.text', 'MAIN_APP_DIALOG.SHARE_EMP_NOTE.title', [item.notes], [], true, 'MAIN_APP_DIALOG.close');
    }

    goBack() {
        this.router.navigateByUrl('/timeapp');
    }

}
